import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const completeCalEventReviewInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
});
//# sourceMappingURL=complete-cal-event-review-input.js.map